import {Component, OnInit, ViewContainerRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr';
import { PanelModule } from 'primeng/primeng';
import { MstStaffService } from '../../configuration/mst-staff/mst-staff.service';
import { MstBankService } from '../../configuration/mst-bank/mst-bank.service';
import { PayoutsService } from './payouts.service';
import { PaginationInstance } from 'ngx-pagination';

@Component({
    selector: 'app-payout-list',
    templateUrl: './payouts.component.html',
    styleUrls: ['./payouts.component.css']
})
export class PayoutsComponent implements OnInit {
    display: boolean = false;
    qString: any = '';
    unitId: any;
    cashcounterList: Array<any> = [];
    mstStaffList: Array<any> = [];
    MainTableArray: Array<any> = [];
    bankList: Array<any> = [];
    currentUser: any = {};
    staffConfig: any = {};
    selectedCc: any = {};
    displayTotAdvance: number = 0;
    totalAdvance: number = 0;
    chequeFlg: Boolean = false;

    isFromCashCounter: Boolean = false;
    isFromStaff: Boolean = false;
    isToCashCounter: Boolean = false;
    isToStaff: Boolean = false;
    isToBank: Boolean = false;
    public config: PaginationInstance = {
        id: 'advanced',
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: 1
    };
    ind = 1;
    Payouts: string = 'list';
    AddForm: FormGroup;
    constructor(
        public fb: FormBuilder,
        public toastr: ToastsManager,
        public PayoutsService: PayoutsService,
        public PanelModule: PanelModule,
        private mstBankService: MstBankService,
        private mstStaffService: MstStaffService,
        vcr: ViewContainerRef
    ) {
        this.toastr.setRootViewContainerRef(vcr);
        this.AddForm = fb.group({
        'payoutServiceType': ['expense'],
        'payoutPayType': ['cash'],
        'payoutRemarks': [null, Validators.required],
        'payoutAmount': ['00.00', Validators.required],
        'payoutChequeNo': [null],
        'payoutFromCcId': fb.group({
            'ccId': [null]
          }),
        'payoutFromStaffId': fb.group({
            'staffId': [null]
          }),
          'payoutToCcId': fb.group({
            'ccId': [null]
          }),
          'payoutToStaffId': fb.group({
            'staffId': [null]
          }),
          'payoutToBankId': fb.group({
            'bankId': [null]
          }),
          'payoutUnitId': fb.group({
            'unitId': [1]
          }),
          'payoutStaffId': fb.group({
            'staffId': [null]
          })
        });
    }

    ngOnInit() {
        this.unitId = sessionStorage.getItem('unitId');
        this.staffConfig = JSON.parse(sessionStorage.getItem('staff_config'));
        this.currentUser = JSON.parse(sessionStorage.getItem('userdetail'));
        this.mstStaffService.getAllDoctorByUnit(sessionStorage.getItem('unitId')).then(resp => {
            this.mstStaffList = resp;
            //console.log('mstStafflist::', this.mstStaffList);
        });
        this.mstBankService.getAllRecordService('', '', '', '', '').then(response => this.bankList = response.content);
        if (this.currentUser.staffCashCounter.length > 0) {
            this.cashcounterList = this.currentUser.staffCashCounter;
            console.log('cashcounterlist::', this.cashcounterList[0].ccId.toString());
            if (this.staffConfig == null) {
                this.AddForm.controls.payoutFromCcId.get('ccId').setValue(this.currentUser.staffCashCounter[0].ccId);
                this.AddForm.controls.payoutToCcId.get('ccId').setValue(this.currentUser.staffCashCounter[0].ccId);
            } else {
                this.selectedCc = this.staffConfig.scCcId;
                this.AddForm.controls.payoutFromCcId.get('ccId').setValue(this.selectedCc.ccId);
                this.AddForm.controls.payoutToCcId.get('ccId').setValue(this.selectedCc.ccId);
            }
        }
        this.staffConfig = JSON.parse(sessionStorage.getItem('staff_config'));
        this.isFromCashCounter = true;
        this.isFromStaff = true;
        this.isToStaff = true;
       this. getfulllist(1);
    }

    onViewSelect(value: any) {
        switch (value) {
          case 'add':
            this.Payouts = 'add'; 
            this.onReset();
            console.log('mstStafflist2::', this.mstStaffList);           
            break;
          case 'edit':
            this.Payouts = 'edit';
            break;
          case 'view':
            this.Payouts = 'view';
            break;
          case 'list':
            this.qString = '';
            this.Payouts = 'list';
            break;
          case 'search':
            this.Payouts = 'search';
            break;
          default:
            this.Payouts = 'list';
            break;
        }
      }

    donordialog() {
        this.display = true;
    }

    onChangePayoutAmount() {
        this.displayTotAdvance = parseFloat(this.totalAdvance + this.AddForm.value.payoutAmount);
    }

    onHideShow() {
        console.log('check', this.AddForm.controls['payoutServiceType'].value);
        //console.log('check', this.AddForm.controls['paytype'].value);
        if (this.AddForm.controls['payoutPayType'].value == 'cash') {
            document.getElementById('field').style.display = 'block';
            this.chequeFlg =  false;
        }
        else if (this.AddForm.controls['payoutPayType'].value == 'cheque') {
            document.getElementById('field').style.display = 'block';
            this.chequeFlg = true;
        }
    // for Expence And Cash Handover Radio button
        if (this.AddForm.controls['payoutServiceType'].value == 'expense') {
            document.getElementById('Allfield').style.display = 'block';
            this.isFromCashCounter = true;
            this.isFromStaff = true;
            this.isToStaff = true;
            this.isToBank = false;
            this.isToCashCounter = false;
            this.AddForm.controls['payoutFromStaffId'].reset();
            this.AddForm.controls['payoutToStaffId'].reset();
            this.AddForm.controls['payoutFromCcId'].reset();
            this.AddForm.controls['payoutRemarks'].reset();
            this.AddForm.controls['payoutAmount'].reset();
            this.AddForm.controls['payoutChequeNo'].reset();
            this.AddForm.controls['payoutToBankId'].reset();
        } else if (this.AddForm.controls['payoutServiceType'].value == 'bankdesposit') {
            document.getElementById('Allfield').style.display = 'block';
            this.isFromCashCounter = true;
            this.isFromStaff = true;
            this.isToCashCounter = false;
            this.isToStaff = false;
            this.isToBank = false;
            this.AddForm.controls['payoutFromStaffId'].reset();
            this.AddForm.controls['payoutFromCcId'].reset();
            this.AddForm.controls['payoutRemarks'].reset();
            this.AddForm.controls['payoutAmount'].reset();
            this.AddForm.controls['payoutChequeNo'].reset();
            this.AddForm.controls['payoutToBankId'].reset();
        } else if (this.AddForm.controls['payoutServiceType'].value == 'cashHandover') {
            document.getElementById('Allfield').style.display = 'block';
            this.isFromCashCounter = true;
            this.isFromStaff = true;
            this.isToCashCounter = true;
            this.isToStaff = true;
            this.isToBank = false;
            this.AddForm.controls['payoutFromStaffId'].reset();
            this.AddForm.controls['payoutToStaffId'].reset();
            this.AddForm.controls['payoutFromCcId'].reset();
            this.AddForm.controls['payoutToCcId'].reset();
            this.AddForm.controls['payoutRemarks'].reset();
            this.AddForm.controls['payoutAmount'].reset();
            this.AddForm.controls['payoutChequeNo'].reset();
            this.AddForm.controls['payoutToBankId'].reset();
        } else if (this.AddForm.controls['payoutServiceType'].value == 'income') {
            document.getElementById('Allfield').style.display = 'block';
            this.isFromStaff = true;
            this.isFromCashCounter = false;
            this.isToStaff = true;
            this.isToBank = false;
            this.isToCashCounter = true;
            this.AddForm.controls['payoutFromStaffId'].reset();
            this.AddForm.controls['payoutToStaffId'].reset();
            this.AddForm.controls['payoutToCcId'].reset();
            this.AddForm.controls['payoutRemarks'].reset();
            this.AddForm.controls['payoutAmount'].reset();
            this.AddForm.controls['payoutChequeNo'].reset();
            this.AddForm.controls['payoutToBankId'].reset();
        }
    }

 //  Modal validation  

    validateModel(model: any) {
        if (model.payoutFromCcId.ccId == null || model.payoutFromCcId.ccId == '' || model.payoutFromCcId.ccId == undefined ) {
            delete model.payoutFromCcId;
        }
        if (model.payoutFromStaffId == undefined || model.payoutFromStaffId.staffId == null || model.payoutFromStaffId.staffId == '') {
            delete model.payoutFromStaffId;
        }
        if (model.payoutToCcId == undefined || model.payoutToCcId.ccId == null || model.payoutToCcId.ccId == '') {
            delete model.payoutToCcId;
        }
        if (model.payoutToStaffId == undefined || model.payoutToStaffId.staffId == null || model.payoutToStaffId.staffId == '') {
            delete model.payoutToStaffId;
        }
        if (model.payoutToBankId == undefined || model.payoutToBankId.bankId == null || model.payoutToBankId.bankId == '') {
            delete model.payoutToBankId;
    
        }
        if (model.payoutUnitId == undefined || model.payoutUnitId.unitId == null || model.payoutUnitId.unitId == '') {
            delete model.payoutUnitId;
        }
        if (model.payoutStaffId == undefined || model.payoutStaffId.staffId == null || model.payoutStaffId.staffId == '') {
            delete model.payoutStaffId;
        }
        if (model.payoutChequeNo == undefined || model.payoutChequeNo == null || model.payoutChequeNo == '') {
            delete model.payoutChequeNo;
        }

        return model;
    }


// Add Accountig
    onAddRecord(model: any) {
        model.unitId = this.unitId;
        model.payoutStaffId.staffId = this.currentUser.staffId;
        model = this.validateModel(model);
        this.PayoutsService.addRecordService(model).then(resp => {
            console.log('resp::', resp);
            if (resp.success === '1') {
                this.toastr.success(resp.msg, 'Success ! ');
                this.ngOnInit();
                this.onViewSelect('list');
             }
    });
    }
// Reset All Droupdown on reset button click
    onReset() {
        this.AddForm.controls['payoutPayType'].setValue('cash');
        this.chequeFlg =  false;
        this.AddForm.controls['payoutFromStaffId'].reset();
        this.AddForm.controls['payoutToStaffId'].reset();
        this.AddForm.controls['payoutFromCcId'].reset();
        this.AddForm.controls['payoutToCcId'].reset();
        this.AddForm.controls['payoutRemarks'].reset();
        this.AddForm.controls['payoutAmount'].reset();
        this.AddForm.controls['payoutChequeNo'].reset();
        this.AddForm.controls['payoutStaffId'].reset();
        this.AddForm.controls['payoutToBankId'].reset();
    }

    getfulllist(page: number){
        this.PayoutsService.getallAccountiglist(page, this.config.itemsPerPage, this.qString, '', '')
        .then(resp => {
          this.MainTableArray = resp.content;
          console.log("resp..123::",this.MainTableArray[0].payoutServiceType,resp);
          this.config.currentPage = page;
          this.config.totalItems = resp.totalElements;
          console.log("total element::",this.config.totalItems);
        });
      }

      getPage(page: number, model: any) {
        model.unitId = this.unitId;
        if (page > 1) {
            this.ind = ((page - 1) * this.config.itemsPerPage) + 1;
        }
        else {
            this.ind = 1;
        }
        //this.loading = true;
        this.config.currentPage = page;
        this.getfulllist(page);
        // this.onsearchbyfilter(model);
    }

     // pagination methods
 onRecordCountChange(records: number) {
    this.config.itemsPerPage = records;
    this.getfulllist(this.config.currentPage);
  }


}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/accounting/payouts/payouts.component.ts